<template>
  <div :class="topBarInsetClass">
    <CommonGoBack label="Cancel" @click="goBack" />
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { usePrevRoute } from '@/use/use-prev-route';
import CommonGoBack from '@/components/_common/CommonGoBack.vue';
import { topBarInsetClass } from '@/components/_common/navbar/topBarInset';

const router = useRouter();
const store = useStore();
const prevRoute = usePrevRoute();

function goBack() {
  if (prevRoute.name === 'GeofenceDetailsView') {
    router.back();
    return;
  }
  router.push({
    name: 'GeofenceListView',
    query: { search: store.getters['geofence/search'] },
  });
}
</script>
